import { useRef, KeyboardEvent, ChangeEvent, CSSProperties, useEffect } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import * as css from './style'
import { t } from '@lingui/core/macro'

interface Props {
  onKeyPress?: (e: KeyboardEvent<HTMLInputElement>) => void
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  searchBoxStyles?: CSSProperties
  defaultValue?: string
}

export const Search = ({
  onChange,
  onKeyPress,
  defaultValue = '',
  searchBoxStyles = {},
}: Props) => {
  const searchRef = useRef<HTMLInputElement>(null)

  // Focus to search on render.
  useEffect(() => {
    searchRef?.current?.focus()
  }, [defaultValue])

  return (
    <css.SearchBox style={searchBoxStyles}>
      <css.InputContainer onClick={() => searchRef?.current?.focus()}>
        <SearchIcon css={css.icon} />
        <input
          role="searchbox"
          css={css.input}
          name="search"
          onKeyDown={onKeyPress}
          onChange={onChange}
          placeholder={t`Search`}
          ref={searchRef}
          defaultValue={defaultValue}
        />
      </css.InputContainer>
    </css.SearchBox>
  )
}
